export enum recruitmentsTypes {
  FETCH_RECRUIMENTS_REQUEST = "FETCH_RECRUIMENTS_REQUEST",
  FETCH_RECRUIMENTS_SUCCESS = "FETCH_RECRUIMENTS_SUCCESS",
  FETCH_RECRUIMENTS_FAILURE = "FETCH_RECRUIMENTS_FAILURE",
}